module.exports = __webpack_public_path__ + "img/feba.b6558887.svg";